/** Dispatched when the Azure AD session can no longer refresh API tokens silently. */
export const AUTH_SESSION_EXPIRED_EVENT = 'lace:auth-session-expired';

let sessionExpired = false;

export function isSessionExpired(): boolean {
  return sessionExpired;
}

export function resetSessionExpired(): void {
  sessionExpired = false;
}

/** Mark session expired and notify listeners (debounced to once per page load). */
export function notifySessionExpired(): void {
  if (sessionExpired) {
    return;
  }
  sessionExpired = true;
  window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT));
}
